
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/shipvista-connect",
      function () {
        return require("private-next-pages/partners/shipvista-connect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/shipvista-connect"])
      });
    }
  